import httpClient from '../httpClient';

const getAll = async (query) => {
  return await httpClient.get('/education_level/');
};

export { getAll };
